import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { MembroDTO } from "../dto/membroDTO";
import { MembroVO } from "../vo/membroVO";

@Injectable({
  providedIn: "root"
})
export class MapperMembro
  implements MapperInterface<MembroDTO, MembroVO> {
  convertVoToDto(e: MembroVO): MembroDTO {
    const membroDTO = new MembroDTO();
    membroDTO.codiceFiscale = e.codiceFiscale;
    membroDTO.cognome = e.cognome;
    membroDTO.email = e.email;
    membroDTO.pec = e.pec;
    membroDTO.presidenteCollegio = e.presidenteCollegio;
    membroDTO.id = e.id;
    membroDTO.nome = e.nome;
    return membroDTO || new MembroDTO();
  }
  convertDtoToVo(t: MembroDTO): MembroVO {
    const membroVO = new MembroVO();
    membroVO.codiceFiscale = t.codiceFiscale;
    membroVO.cognome = t.cognome;
    membroVO.email = t.email;
    membroVO.pec = t.pec;
    membroVO.presidenteCollegio = t.presidenteCollegio;
    membroVO.id = t.id;
    membroVO.nome = t.nome;
    return membroVO || new MembroVO();
  }
  convertListVoToDto(e: MembroVO[]): MembroDTO[] {
    const membroDTOList = new Array<MembroDTO>();
    if (e != null && e.length > 0) {
      e.forEach(membroVO => {
        membroDTOList.push(this.convertVoToDto(membroVO));
      });
    }
    return membroDTOList || new Array<MembroDTO>();
  }

  convertListDtoToVo(t: MembroDTO[]): MembroVO[] {
    // console.log("[MapperStruttura] StrutturaDTOList => StrutturaVOList");
    const membroVOList = new Array<MembroVO>();
    if (t != null && t.length > 0) {
      t.forEach(membroDTO => {
        membroVOList.push(this.convertDtoToVo(membroDTO));
      });
    }
    return membroVOList || new Array<MembroVO>();
  }
}
